import { NgModule } from '@angular/core';

import { MyDisableIfHasNotPermissionDirective } from "@bt/directives/disable.directive";
import { MyHideIfHasNotPermissionDirective } from "@bt/directives/hide.directive";
import { RequiredLength } from './length.directive';

@NgModule({
  imports: [
  ],
  exports:[    
    MyDisableIfHasNotPermissionDirective,
    MyHideIfHasNotPermissionDirective,
    RequiredLength
  ],
  declarations: [
    MyDisableIfHasNotPermissionDirective,
    MyHideIfHasNotPermissionDirective,
    RequiredLength
  ],
})
export class DirectiveModule { }


// WEBPACK FOOTER //
// ./src/app/directives/directive.module.ts